import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import profileImg from "../../assets/img/images.png";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./style.scss";
import FAQModalHO from "../../User/Components/FAQ-myaccount";
import { Modal, Collapse } from "react-bootstrap";
import { AppSettings } from "../../constants";

class HomeownerSidebar extends Component {
  static propTypes = {
    history: PropTypes.object,
    user: PropTypes.object,
    tenantProfile: PropTypes.object,
    dispatch: PropTypes.func,
    routes: PropTypes.any,
    location: PropTypes.object,
    lotProfile: PropTypes.object,
    izendaStore: PropTypes.object,
    hobrand: PropTypes.array,
    HomeownerLots: PropTypes.array,
  };

  constructor(props) {
    super(props);

    this.state = {
      openMenu: null,
      showFaqModal: false,
      previewModalOpen: false,
      previewContent: null,
    };
  }

  componentDidMount() {
    this.fetchCustomTerms();
  }

  fetchCustomTerms = () => {
    const tokenKey = (AppSettings && AppSettings.S1_TOKEN) ? AppSettings.S1_TOKEN : 's1-token';
    const token = localStorage.getItem(tokenKey);
    
    if (token) {
      let baseUrl = (AppSettings && AppSettings.CURRENT_SITE_URI) ? AppSettings.CURRENT_SITE_URI : 'https://clubmahindra.siteoneservicesdemo.com';
      if (document.location.protocol === 'https:') {
        baseUrl = baseUrl.replace('http://', 'https://');
      }

      fetch(`${baseUrl}/api/settings/get-custom-terms`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      })
        .then(res => res.json())
        .then(data => {
          window.customTerms = data;
          this.forceUpdate();
        })
        .catch(err => {
          console.warn('Homeowner sidebar failed to fetch custom terms:', err);
        });
    }
  };

  toggleCollapse = (e, name) => {
    e.preventDefault();
    let current = this.props.parent.state[name];
    this.props.parent.setState({ [name]: !current });
  };

  toggleDropdown = (menuPosition) => {
    this.setState((prevState) => ({
      openMenu: prevState.openMenu === menuPosition ? null : menuPosition,
    }));
  };

  openDropdown = (menuPosition) => {
    this.setState({ openMenu: menuPosition });
  };

  closeDropdown = () => {
    this.setState({ openMenu: null });
  };

  toggleFaqModal = () => {
    this.setState((prevState) => ({
      showFaqModal: !prevState.showFaqModal,
      previewModalOpen: false,
      openMenu: null,
    }));
  };

  handleSetupGuide = () => {
    axios
      .get(
        "https://homeowner.siteoneservicesdemo.com/api/v2/homeowner/account/welcome-guide"
      )
      .then((res) => {
        if (res.data) {
          this.openPreview(res.data.url, res.data.name);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  openPreview = (url, fileName) => {
    this.setState({
      previewModalOpen: true,
      showFaqModal: false,
      openMenu: null,
      previewContent: {
        url,
        fileName,
      },
    });
  };

  closePreview = () => {
    this.setState({
      previewModalOpen: false,
      previewContent: null,
    });
  };

  renderPreviewModal = () => {
    const { previewModalOpen, previewContent } = this.state;
    if (!previewContent) return null;

    return (
      <Modal
        show={previewModalOpen}
        onHide={this.closePreview}
        centered
        className="custom-preview-modal"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{previewContent.fileName}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center", minHeight: "500px" }}>
          <div style={{ height: "70vh", width: "100%" }}>
            <iframe
              src={previewContent.url}
              title={previewContent.fileName}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
              frameBorder="0"
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  checkGroupActive = (name) => {
    const groupMenu = this.props.parent.state.groupMenu;
    const activeRoute = this.props.parent.activeRoute;

    let foundGroup = groupMenu.find((x) => x.group === name);
    let menuItem = (foundGroup && foundGroup.items) || [];

    const menuFilter = menuItem.filter((item) => activeRoute(item.path));
    return menuFilter.length > 0 ? "active" : "";
  };

  renderGroupMenu = (groups) => {
    const state = this.props.parent.state;
    return Object.keys(groups).map((key) => {
      const group = groups[key];
      const isOpen = state[key];
      return (
        <li
          key={key}
          className={`group-menu-parent ${this.checkGroupActive(key)} ${group.className || ""
            }`}
        >
          <a onClick={(e) => this.toggleCollapse(e, key)}>
            <i className={group.icon} />
            <p>
              {group.name}
              <b className={isOpen ? "caret" : "caret rotate-270"} />
            </p>
          </a>
          <Collapse in={isOpen}>
            <ul className="nav">
              {group.subGroup
                ? group.subGroup.map((sub, idx) => {
                  const list = group.items.filter(
                    (x) => x.menu.subGroup === sub.key,
                  );
                  return (
                    <React.Fragment key={idx}>
                      <div className="sidebar__sub-group__label">
                        {sub.name}
                      </div>
                      {this.renderMenuItems(list)}
                    </React.Fragment>
                  );
                })
                : this.renderMenuItems(group.items)}
            </ul>
          </Collapse>
        </li>
      );
    });
  };

  getSidebarTranslateName = (originalName) => {
    if (!window.customTerms) return originalName;
    
    let textStr = '';
    if (typeof originalName === 'string') {
      textStr = originalName.toLowerCase().trim();
    } else if (originalName && originalName.props && originalName.props.translateKey) {
      textStr = originalName.props.translateKey.toLowerCase().trim();
    }

    const capitalize = (str) => {
      if (!str || typeof str !== 'string') return str;
      return str.split(' ').map(word => word ? word.charAt(0).toUpperCase() + word.slice(1) : '').join(' ');
    };
    
    if (textStr === 'project' || textStr === 'projects') {
       let term = window.customTerms.project ? window.customTerms.project + 's' : originalName;
       return capitalize(term);
    }
    if (textStr === 'lot' || textStr === 'lots') {
       let term = window.customTerms.lot ? window.customTerms.lot + 's' : originalName;
       return capitalize(term);
    }
    if (textStr === 'homeowner' || textStr === 'homeowners') {
       let term = window.customTerms.homeowner ? window.customTerms.homeowner + 's' : originalName;
       return capitalize(term);
    }
    if (textStr === 'punch list' || textStr === 'punch lists' || textStr === 'blue tape') {
       let term = window.customTerms.punchlist ? window.customTerms.punchlist : originalName;
       return capitalize(term);
    }
    
    return originalName;
  };

  renderMenuItems = (items) => {
    const { parent } = this.props;
    if (!items) return null;

    return items.map((route, key) => {
      const isActive = parent.activeRoute(route.path);
      let displayName = this.getSidebarTranslateName(route.menu.name);

      return (
        <li className={`${isActive} ${route.menu.className || ""}`} key={key}>
          <NavLink
            exact
            to={{
              pathname: route.path,
              search:
                this.props.location.pathname === route.path
                  ? this.props.location.search
                  : null,
            }}
            activeClassName="active"
            className="nav-link"
          >
            <i
              className={`${route.menu.icons ? route.menu.icons : route.menu.iconClass
                } sidebar-mini`}
              style={{ fontSize: "22px" }}
            />
            {/* <i className={`sidebar-mini`} style={{ fontSize: "18px" }}>
              {route.menu.icons || route.menu.iconClass}
            </i> */}

            <p>{displayName}</p>
          </NavLink>
        </li>
      );
    });
  };

  renderItems = (groupMenuItems, groupMenu) => {
    const sorted = [...groupMenuItems, ...groupMenu].sort((a, b) => {
      if (!a.menu.order) return -1;
      if (!b.menu.order) return 1;
      return a.menu.order - b.menu.order;
    });

    return sorted.map((item) =>
      item.menu.isGroup
        ? this.renderGroupMenu({ [item.group]: item })
        : this.renderMenuItems([item]),
    );
  };

  render() {
    const { parent } = this.props;

    const groupMenuItems = parent.props.items.filter(
      (route) =>
        !(
          route.menu.group &&
          parent.props.groupMenu.some((x) => x.group === route.menu.group)
        ),
    );
    console.log("🚀 ~ groupMenuItems:", groupMenuItems);

    const { groupMenu } = parent.state;
    console.log("🚀 ~ groupMenu:", groupMenu);

    const renderProfileMenu = (menuPosition) => {
      if (menuPosition === "top") {
        return (
          <ul className="nav">
            <li>
              <a className="nav-link" onClick={this.toggleFaqModal}>
                <i className="pe-7s-help1 sidebar-mini" style={{ fontSize: "22px" }} />
                <p>FAQ / Help</p>
              </a>
            </li>
            <li>
              <a className="nav-link" onClick={this.handleSetupGuide}>
                <i className="pe-7s-notebook sidebar-mini" style={{ fontSize: "22px" }} />
                <p>Getting Started Guide</p>
              </a>
            </li>
          </ul>
        );
      }
      return (
        <ul
          className="dropdown-menu"
          role="menu"
          style={{ display: this.state.openMenu === menuPosition ? "block" : "none" }}
        >
          <li role="presentation">
            <a role="menuitem" href="/my-profile" onClick={this.closeDropdown}>
              My Account
            </a>
          </li>
          <li role="separator" className="divider"></li>
          <li role="presentation">
            <a
              role="menuitem"
              href="/logout?action=true"
              className="text-danger"
              onClick={this.closeDropdown}
            >
              Logout
            </a>
          </li>
        </ul>
      );
    };

    return (
      <div
        className="homeowner-sidebar sidebar custom-rounded"
        style={{
          borderRadius: "0px 10px 10px 0px",
        }}
      >
        <div className="sidebar-background" />
        <div
          className="sidebar-wrapper centered-wrapper"
          ref="sidebarWrapper"
        >
          <ul className="nav icon-list">
            {this.renderItems(groupMenuItems, groupMenu)}
          </ul>
          <ul className="nav digital-mike-nav">
            <li
              className={`group-menu-parent`}
            >
              <a
                onClick={(e) => {
                  e.preventDefault();
                  this.toggleDropdown("top");
                }}
                aria-expanded={this.state.openMenu === "top"}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src="/images/person.png"
                  alt="Profile shortcut"
                  className="person-shortcut-img"
                  style={{
                    width: "30px",
                    height: "30px",
                    marginRight: "10px",
                    objectFit: "contain",
                  }}
                />
                <p style={{ margin: 0, flex: 1 }}>
                  Digital Mike
                  <b className={this.state.openMenu === "top" ? "caret" : "caret rotate-270"} />
                </p>
              </a>
              <Collapse in={this.state.openMenu === "top"}>
                {renderProfileMenu("top")}
              </Collapse>
            </li>
          </ul>
        </div>
        <div className="sidebar-bottom">
          {/* <i class="fa fa-question-circle-o" aria-hidden="true"></i> */}

          <div className={`dropup ${this.state.openMenu === "bottom" ? "open" : ""}`}>
            <button
              className="btn btn-default dropdown-toggle"
              type="button"
              aria-haspopup="true"
              aria-expanded={this.state.openMenu === "bottom"}
              onClick={() => this.toggleDropdown("bottom")}
            >
              <img
                src={
                  this.props.user.profilePictureUrl
                    ? this.props.user.profilePictureUrl
                    : profileImg
                }
                alt="Profile"
                className="profile-img"
              />
            </button>
            {renderProfileMenu("bottom")}
          </div>
        </div>
        {this.state.showFaqModal && (
          <FAQModalHO
            isOpen={this.state.showFaqModal}
            closeModal={this.toggleFaqModal}
            dispatch={this.props.dispatch}
          />
        )}
        {this.renderPreviewModal()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.UserStore.UserProfile,
    tenantProfile: state.authReducer.tenantProfile,
    lotProfile: state.LotStore.LotProfile,
    izendaStore: state.IzendaStore,
    hobrand: state.authReducer.hobrand,
    HomeownerLots: state.LotStore.HomeownerLots,
    i18nState: state.i18nState,
  };
};

export default connect(mapStateToProps)(HomeownerSidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar-Homeowner.js